import { makeStyles, Theme } from "@material-ui/core";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

export const useStyles = makeStyles((theme: Theme) => {
  const {
    gray30,
    blue,
    faqFabBg,
    faqContactIconFilter,
  } = useNormalizedBrandPaletteValues(theme);

  return {
    iconButton: {
      cursor: "pointer",
      transition: "all .2s ease-in-out",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    faqButton: {
      color: theme.palette.common.white,
      backgroundColor: faqFabBg,
      fontSize: 28,
      fontWeight: theme.typography.fontWeightBold,
      position: "fixed",
      right: theme.spacing(4),
      bottom: theme.spacing(12),
      [theme.breakpoints.down("sm")]: {
        right: theme.spacing(1),
        bottom: theme.spacing(5),
      },
    },
    link: {
      fontWeight: theme.typography.fontWeightBold,
      color: blue,
      marginLeft: theme.spacing(1),
    },
    modalRoot: {
      border: `2px solid ${theme.palette.common.black}`,
      boxShadow: theme.shadows[5],
      borderRadius: theme.shape.borderRadius,
    },
    accordionDetails: {
      color: gray30,
      fontSize: `${14 / 16}rem`,
      padding: theme.spacing(0, 2),
    },
    accordionSummaryContent: {
      margin: `0 !important`,
    },
    accordionExpandIcon: {
      padding: 0,
    },
    accordionExpanded: {
      margin: `0 !important`,
    },
    paragraph: {
      marginBottom: theme.spacing(2),
      maxWidth: "600px",
    },
    question: {
      fontWeight: theme.typography.fontWeightBold,
      [theme.breakpoints.down("xs")]: {
        marginTop: theme.spacing(1),
      },
    },
    sectionHeader: {
      boxShadow: `inset 0rem -0.75rem 0.25rem -0.25rem ${theme.palette.primary.main}`,
      fontSize: `1.25rem`,
    },
    supportIcon: {
      width: theme.spacing(2),
      height: theme.spacing(22 / 8),
      filter: faqContactIconFilter,
    },
  };
});
